<template>
    <div class="o-container -container-sm">
        <h2 class="o-title-hero u-mb-md u-text-outline-color-2-light">
            Calendrier <br>des activités
        </h2>
        <div class="u-bg-color-white u-py-lg o-calendar__wrap">
            <div class="o-container">
                <div class="o-calendar">
                    <div class="o-calendar__header u-mb-md">
                        <div class="o-title-3 o-calendar__month">
                            <button class="o-calendar__month__action -month-prev" aria-label="Mois précédent"
                                type="button" @click="fetchPreviousMonth()">
                                <Image id="arrow-right" class="-ico-arrow-left" />
                            </button>
                            <span class="o-calendar__month__label">{{ monthStringUpper }} {{ year }}</span>
                            <button class="o-calendar__month__action -month-next" aria-label="Mois suivant"
                                type="button" @click="fetchNextMonth()">
                                <Image id="arrow-right" class="-ico-arrow-right" />
                            </button>
                        </div>

                        <div class="o-calendar__filters c-overlay-mobile">
                            <div class="c-overlay-mobile__header">
                                <div class="c-overlay-mobile__close"
                                    @click="classToggle('html', 'has-overlay-mobile-open', '.c-overlay-mobile')"
                                    aria-label="Fermer le panneau pour filtrer les résultats">
                                    Fermer
                                    <Image id="close" class="-ico-close" />
                                </div>
                            </div>
                            <div class="o-switch__listing">
                                <div v-for="t in event_types" class="o-switch__wrap" :class="'-filter-theme-'+t.class">
                                    <div class="o-switch__label">
                                        <div class="o-calendar__legend"></div>
                                        <span class="sr-only">Activer le filtre </span>{{ t.name }}
                                    </div>
                                    <div class="o-switch__toggle">
                                        <label class="o-switch" :aria-label="'Activer le filtre - '+t.name">
                                            <input class="o-switch__checkbox" :value="t.slug" type="checkbox"
                                                v-model="selectedCategories">
                                            <span class="o-switch__slider"></span>
                                        </label>
                                    </div>
                                </div>
                                <div class="o-switch__wrap">
                                    <div class="o-switch__label">
                                        <span class="sr-only">Activer le filtre </span>En présence
                                    </div>
                                    <div class="o-switch__toggle">
                                        <label class="o-switch" aria-label="Activer le filtre - En présence">
                                            <input class="o-switch__checkbox" value="presence" type="checkbox"
                                                v-model="selectedTypeActivite">
                                            <span class="o-switch__slider"></span>
                                        </label>
                                    </div>
                                </div>
                                <div class="o-switch__wrap">
                                    <div class="o-switch__label">
                                        <span class="sr-only">Activer le filtre </span>En ligne
                                    </div>
                                    <div class="o-switch__toggle">
                                        <label class="o-switch" aria-label="Activer le filtre - En ligne">
                                            <input class="o-switch__checkbox" value="ligne" type="checkbox"
                                                v-model="selectedTypeActivite">
                                            <span class="o-switch__slider"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="c-overlay-mobile__trigger__wrap">
                            <button class="c-overlay-mobile__trigger" type="button"
                                @click="classToggle('html', 'has-overlay-mobile-open', '.c-overlay-mobile')">
                                Filtrez
                                <Image id="filter" class="-ico-filter" />
                            </button>
                        </div>
                    </div>

                    <div class="o-calendar__main">
                        <div class="o-calendar__layout">
                            <div class="o-calendar__week">
                                <div class="o-calendar__week__item">
                                    <div class="o-title-4 o-calendar__week__label">Di</div>
                                </div>
                                <div class="o-calendar__week__item">
                                    <div class="o-title-4 o-calendar__week__label">Lu</div>
                                </div>
                                <div class="o-calendar__week__item">
                                    <div class="o-title-4 o-calendar__week__label">Ma</div>
                                </div>
                                <div class="o-calendar__week__item">
                                    <div class="o-title-4 o-calendar__week__label">Me</div>
                                </div>
                                <div class="o-calendar__week__item">
                                    <div class="o-title-4 o-calendar__week__label">Je</div>
                                </div>
                                <div class="o-calendar__week__item">
                                    <div class="o-title-4 o-calendar__week__label">Ve</div>
                                </div>
                                <div class="o-calendar__week__item">
                                    <div class="o-title-4 o-calendar__week__label">Sa</div>
                                </div>
                            </div>

                            <div class="o-calendar__days">
                                <div v-for="day in blankDaysBefore" class="o-calendar__days__item"></div>
                                <template v-for="day in [...Array(new Date(year, month, 0).getDate()).keys()]">
                                    <div v-if="eventsOf(day + 1).length>0 || !isMobile()"
                                        class="o-calendar__days__item">
                                        <div class="o-title-5 o-calendar__days__label">{{ day + 1 }}<span>{{ monthString
                                                }}</span></div>
                                        <div class="o-calendar__events">
                                            <a v-for="event in eventsOf(day + 1)" :key="event.id" :href="event.link"
                                                class="o-calendar__events__item"
                                                :class="'-filter-theme-' + getCategoryClass(event)" target="_blank">
                                                <div class="o-calendar__legend"></div>
                                                <div class="o-calendar__events__title">
                                                    <template v-if="!event.hide_hour">{{ event.hour.replace(/^0+/, '')}} |&nbsp;</template>
                                                    <span v-html="event.title"></span>
                                                </div>
                                            </a>
                                        </div>
                                        <div class="o-tooltip">
                                            <div class="o-tooltip__content">
                                                <a v-for="event in eventsOf(day + 1)" :key="event.id" :href="event.link"
                                                    class="o-calendar__events__item"
                                                    :class="'-filter-theme-' + getCategoryClass(event)" target="_blank">
                                                    <div class="o-calendar__legend"></div>
                                                    <div class="o-calendar__events__title">
                                                        <template v-if="!event.hide_hour">{{ event.hour.replace(/^0+/,'') }} |&nbsp;</template>
                                                        <span v-html="event.title"></span>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <div v-for="day in blankDaysAfter" class="o-calendar__days__item"></div>
                            </div>
                            <div class="o-calendar__empty" v-if="!events.length">
                                <p class="o-title-4">
                                    Aucune activité pour ce mois-ci.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//import moment from 'moment';
import Image from './image.vue';

export default {
    components: {
        Image,
    },
    props: {
        startDate: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            disableLoading: true,
            selectedTypeActivite: [],
            selectedCategories: [],
            currentDate: '2000-01-01',
            events: [],
            event_types: [],
            controller: null,
        };
    },
    mounted() {
        //console.log(this.currentDate);
        this.currentDate = this.startDate
        this.getMonthData(this.currentDate);
    },
    watch: {
        selectedCategories() {
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 100);
        },
        selectedTypeActivite() {
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 100);
        },
    },
    computed: {
        month() {
            return this.currentDate.split('-')[1];
        },
        monthStringUpper() {
           let month = this.monthString;
           if (month) {
               return month.charAt(0).toUpperCase() + month.slice(1);
            }
            
            return '';
        },
        monthString() {
            const months = [
                'janvier',
                'février',
                'mars',
                'avril',
                'mai',
                'juin',
                'juillet',
                'août',
                'septembre',
                'octobre',
                'novembre',
                'décembre',
            ];
            return months[this.month - 1];
        },
        year() {
            return this.currentDate.split('-')[0];
        },
        blankDaysBefore() {
            return new Array(new Date(this.year, this.month - 1, 1).getDay());
        },
        blankDaysAfter() {
            return new Array(6 - new Date(this.year, this.month, 0).getDay());
        },
    },
    methods: {
        getCategoryClass(event) {
            let type = this.event_types.find((type) => type.slug === event.type)
            if (type) {
                return type.class;
            }
            return '';
        },
        getMonthData(date, direction = '') {
            if (!this.disableLoading) {
                document.body.parentElement.classList.add('page-is-loading');
            } else {
                this.disableLoading = false;
            }
            if (this.controller) {
                this.controller.abort();
            }
            this.controller = new AbortController();
            fetch(WPURLS.apiurl + 'calendrier?date=' + date + '&direction=' + direction, {
                method: 'GET',
                signal: this.controller.signal,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    this.currentDate = data.requested_date;
                    this.events = data.events;
                    this.event_types = data.event_types;
                    document.body.parentElement.classList.remove('page-is-loading');

                    if (this.selectedCategories.length === 0) {
                        this.event_types.forEach((type) => {
                            this.selectedCategories.push(type.slug);
                        });
                    }
                    if (this.selectedTypeActivite.length === 0) {
                        this.selectedTypeActivite.push('presence');
                        this.selectedTypeActivite.push('ligne');
                    }

                    setTimeout(() => {
                        window.dispatchEvent(new Event('resize'));
                    }, 100);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    document.body.parentElement.classList.remove('page-is-loading');
                });

        },
        fetchPreviousMonth() {
            //let date = moment(this.currentDate).subtract(1, 'months').format('YYYY-MM') + '-01';
            this.getMonthData(this.currentDate, 'prev');
        },
        fetchNextMonth() {
            //let date = moment(this.currentDate).add(1, 'months').format('YYYY-MM') + '-01';
            this.getMonthData(this.currentDate, 'next');
        },
        eventsOf(day) {
            let events = this.events.filter((event) => {
                if (this.selectedCategories.length > 0) {
                    if (!this.selectedCategories.includes(event.type)) {
                        return false;
                    }
                }
                if (this.selectedTypeActivite.length > 0 && this.selectedTypeActivite.length < 2) {
                    if (!this.selectedTypeActivite.includes(event.type_activite) && event.type_activite!='hybride') {
                        return false;
                    }
                }
                return event.date.split('-')[2] == day;
            });

            // reorder by hour
            events.sort((a, b) => {
                return a.hour.localeCompare(b.hour);
            });

            return events;
        },
        classToggle(target, className, module) {
            document.querySelector(target).classList.toggle(className);
            let ariaHiddenElm = this.$el.querySelector(module);
            if(ariaHiddenElm && ariaHiddenElm.getAttribute('aria-hidden') == "false"){
                ariaHiddenElm.setAttribute('aria-hidden','true')
            }else if(ariaHiddenElm){
                ariaHiddenElm.setAttribute('aria-hidden','false')
            }
        },
        isMobile() {
            // html has class is-mobile
            return document.querySelector('html').classList.contains('is-mobile');
        }
    },
};
</script>